import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact } from '@fortawesome/free-brands-svg-icons';
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { faFingerprint } from '@fortawesome/free-solid-svg-icons'
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    '.NET',
    "React",
    "TypeScript",
    "JavaScript",
    "Docker",
    "APIs",
    "Postman",
    "Windows Services",
    "MSSQL",
    "Daqpaq"
];

const labelsSecond = [
    'MSSQL',
    "PostgresQL",
    "Tableau",
    "RDBMS",
    "Data Modeling",
    "data visualization",
    "Data Optimization",
    "PostgresQL",
    "MongoDB",
    "Linux"
];

const labelsThird = [
    "Linux",
    "Symantec DLP",
    "EnCase",
    "FTK",
    "Endpoint Security & Monitoring Tools",
    "Forensic Analysis & Investigation Platforms"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>/ expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Full Stack Development</h3>
                    <p>I have developed a wide range of full-stack applications from the ground up, utilizing modern technologies such as React, TypeScript, and SQL/NoSQL databases, demonstrating proficiency across the entire software development lifecycle. One key accomplishment was spearheading the design, development, and deployment of an enterprise-scale telemetry platform built with .NET, React, and MSSQL. This solution seamlessly integrated DAQPAQ, APIs, and Windows Services for rapid data ingestion and analysis, delivering real-time device insights to stakeholders via Tableau dashboards. In a separate project, I created a comprehensive manufacturing automation platform that tracked materials from order placement through final fulfillment and shipping, orchestrating dozens of factory locations with .NET, MSSQL, and Windows Services. Both solutions earned recognition for their exceptional performance and data accuracy, facilitating critical decision-making across security, infrastructure, and manufacturing teams at an organizational level.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDatabase} size="3x"/>
                    <h3>Data Science & Architecture</h3>
                    <p>I have architected and developed enterprise-level data platforms, designing robust relational models with a strong focus on optimization and scalability. In addition to these initiatives, I created and led a specialized data science function focused on advanced security analytics, delivering proactive insights to address emerging threats. By prioritizing data integrity and aligning architecture decisions with both business objectives and technical requirements, I have consistently built high-performance systems that streamline data management and improve accessibility. This combined expertise in data strategy and team leadership has been instrumental in driving efficiency and enabling data-driven decision-making across the organization.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faFingerprint} size="3x"/>
                    <h3>Digital Forensics</h3>
                    <p>Building on my formal education in Computer & Digital Forensics, I have spent the last 10 years refining data loss prevention (DLP) programs and conducting in-depth investigations of potential security breaches. From mentoring teams on DLP best practices to overseeing the smooth migration of tens of thousands of endpoint agents, I’ve consistently enhanced organizational security posture. My hands-on experience with incident response, combined with a deep understanding of forensic methodologies, has enabled me to quickly identify vulnerabilities and safeguard critical information assets.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;